exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* purgecss start ignore */\n.addToCartDisabled[data-v-2b0f9c64] {\n  background: #48bb78 !important;\n  cursor: pointer;\n  display: block;\n}\n.carousel-cell[data-v-2b0f9c64] {\n  width: 100%;\n  height: auto;\n  position: absolute;\n  left: 0%;\n}\n.carousel-cell-image[data-v-2b0f9c64] {\n  width: 100%;\n  display: block;\n}\n.caption-slider-landing[data-v-2b0f9c64] {\n  background: white;\n  opacity: 0.8;\n  width: 100% !important;\n  position: absolute;\n  bottom: 0 !important;\n}\n\n/* purgecss end ignore */\n", ""]);

// exports
